<div class="cartModel">
    <div class="cx-modal-content">
    <h4 class="modelH">
        {{ "welcomePackage.itemAddCartHeader" | cxTranslate }}
    </h4>
    <div class="content">
        <p *ngIf="this.addedToCart.length>0">{{ "welcomePackage.addedItemShippingCart" | cxTranslate }}</p>
        <p *ngIf="errorMsg"><i class="material-icons">
            warning</i>
            <span *ngFor="let item of unavailabeItem; let i = index"> 
                {{ "welcomePackage.part" | cxTranslate }} # {{item}}<span *ngIf="i < unavailabeItem.length - 1">,</span> 
            </span>
            <span> {{ "welcomePackage.addErrorMsg" | cxTranslate }}</span>
        </p>
    </div>
    <div class="cstmBtn">
        <span class="link" (click)="navigateToCart()">{{ "welcomePackage.viewShoppingCart" | cxTranslate }}</span>
        <button class="vs-primary-btn sample-btn" (click)="dismissModal()">
            <span>{{ "welcomePackage.contShopingbBtn" | cxTranslate }}</span>
        </button>
    </div>
    </div>
</div>
